/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowCircleUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm39.59375,103.59375a7.99708,7.99708,0,0,1-11.3125,0L136,107.3125V168a8,8,0,0,1-16,0V107.3125L99.71875,127.59375a7.99915,7.99915,0,0,1-11.3125-11.3125L122.334,82.35352a8.02367,8.02367,0,0,1,11.332,0l33.92773,33.92773A7.99708,7.99708,0,0,1,167.59375,127.59375Z" />
    </Svg>
  );
}

export default ArrowCircleUp;
